import React from 'react'

import { SidePopupContact } from './SidePopupContents'

export const getSidePopupContent = (params = {}) => {
  const { type, data, toggle } = params
  if (type === 'contact') return <SidePopupContact contact={data} toggle={toggle} />
  return null
}

export const getPrimaryContact = (contact = {}) => {
  const { phones, emails, urls } = contact
  if (phones?.length) return phones[0].phone
  if (emails?.length) return emails[0].email
  if (urls?.length) return urls[0].url
  return ''
}
